export type Size = { width: number; height: number }

type Props = {
  path: string
  size?: Size
}

const DEFAULT_SIZE: Size = {
  width: 100,
  height: 20,
}

export const HistoricalGraph = ({ path, size = DEFAULT_SIZE }: Props) => (
  <div style={{ ...size }}>
    <div className="h-full w-full grid-area-[chart]">
      <svg className="hover:[&>path]:stroke-(--fg-brand-primary)">
        <path
          stroke={"#737987"}
          strokeOpacity={0.9}
          strokeWidth={1.6}
          fill="none"
          d={path}
        />
      </svg>
    </div>
  </div>
)
